/** Normaliza Nota 1 (uso interno) del maestro de proveedores. */
export const normalizarNotasProveedor = (notas?: string | null): string =>
  String(notas ?? '').replace(/\s+/g, ' ').trim();
